import React, { useState } from 'react'
import styled from 'styled-components'
import { FormLabel } from '../FormLabel'
const isMobile = window.innerWidth < 712

const StyledCustomSelect = styled.div<{
  isSelected?: boolean
  open: boolean
  maxHeight: number
}>`
  width: 100%;
  position: relative;
  font-family: var(--font-plex);
  height: 50px;
  line-height: 1.2em;
  .entries {
    background-color: #fff;
    pointer-events: none;
    padding: 0;
    padding-top: ${({ open }) => (open ? '0px' : '0px')};
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    display: inline-block;
    -webkit-box-shadow: ${({ open }) =>
      open ? '0 6px 11px 0 rgba(0, 0, 0, 0.2)' : 'unset'};
    box-shadow: ${({ open }) =>
      open ? '0 6px 11px 0 rgba(0, 0, 0, 0.2)' : 'unset'};
    z-index: ${({ open }) => (open ? 900 : 1)};
    box-sizing: border-box;

    transition: max-height 0.2s ease;
    max-height: ${({ open, maxHeight }) => (open ? maxHeight + 'px' : '0')};
    overflow: hidden;
    width: 100%;
  }
`
const StyledSelectOption = styled.button<{
  isPlaceholder?: boolean
  open: boolean
  isSelected: boolean
  disabled: boolean
}>`
  pointer-events: all;
  color: var(--brandblue-main);
  width: 100%;
  border: 0;
  font-size: 16px;
  font-family: var(--font-plex);
  z-index: 100;
  padding: 15px;
  text-align: left;
  box-sizing: border-box;

  user-select: none;
  height: 50px;
  letter-spacing: 0.5px;
  margin: 0;

  &:hover {
    cursor: ${({ disabled }) => (!disabled ? 'pointer' : undefined)};
    background-color: ${({ disabled }) =>
      !disabled ? 'var(--brandblue-bright-4)' : '#fff'};
  }
  font-weight: ${({ isSelected, open, isPlaceholder }) =>
    isPlaceholder ? '300' : isSelected ? '700' : open ? '400' : '700'};
  &:first-letter {
    text-transform: uppercase;
  }
  letter-spacing: 0.5;
  background-color: ${({ isSelected, open }) => (open ? 'white' : 'white')};
  color: ${({ isSelected, open, isPlaceholder }) =>
    isPlaceholder
      ? 'var(--brandblue-main)'
      : isSelected
      ? 'var(--brandblue-main)'
      : open
      ? 'var(--brandblue-main)'
      : 'var(--brandblue-main)'};
`

const StyledArrow = styled.div<{ open: boolean }>`
  display: inline-block;
  border-top: 2.5px solid var(--brandblue-main);
  border-right: 2.5px solid var(--brandblue-main);

  position: absolute;
  right: 15px;
  top: ${({ open }) => (open ? '22px' : '18px')};
  text-align: center;
  width: 10px;
  height: 10px;
  pointer-events: none;
  transform-origin: center;
  transform: rotate(${props => (props.open ? '315deg' : '135deg')});
  z-index: ${({ open }) => (open ? 0 : 1)};

  transition: transform 0.2s ease-in, top 0.2s ease;
`

export const Select = ({
  entries,
  label = '',
  current,
  change,
  noLabel = false,
  disabled,
  text
}: {
  label?: string
  current: string
  entries: { label: string; id: string }[]
  change: (propid: string) => void
  noLabel?: boolean
  disabled: boolean
  text: string | JSX.Element | string[] | string[][]
}) => {
  const [isOpen, setOpen] = useState(false)
  const currentlabel = entries.find(f => f.id === current) || { label: '' }
  return (
    <div className='Select' style={{ lineHeight: 0 }}>
      {!noLabel && <FormLabel>{label}</FormLabel>}
      <StyledCustomSelect
        isSelected={currentlabel.label !== ''}
        open={isOpen}
        maxHeight={(entries.length + 1) * 50}
      >
        <StyledSelectOption
          isPlaceholder={currentlabel.label === ''}
          open={false}
          onClick={() => {
            if (!disabled) setOpen(!isOpen)
          }}
          isSelected={false}
          disabled={disabled}
        >
          {currentlabel.label || text}
        </StyledSelectOption>
        <div className='entries'>
          {entries.map((m, i) => {
            return (
              <StyledSelectOption
                key={'Key_Select_' + i}
                open={isOpen}
                onClick={() => {
                  change(m.id)
                  setOpen(false)
                }}
                isSelected={current === m.id}
                disabled={disabled}
              >
                {m.label}
              </StyledSelectOption>
            )
          })}
        </div>
        {!disabled && <StyledArrow open={isOpen} />}
      </StyledCustomSelect>{' '}
    </div>
  )
}
